import { sharedStore } from "../stores/SharedStore";
export function makeCharacterConfigurationThumbnailVersion(character) {
  var _sharedStore$getAnima;

  const animationId = (_sharedStore$getAnima = sharedStore.getAnimationByName(character.animationAssetName)) === null || _sharedStore$getAnima === void 0 ? void 0 : _sharedStore$getAnima.id;
  const animationSkins = character.animationSkins;
  const tintColorHex = character.tintColorHex;
  return animationId + animationSkins + tintColorHex;
}